
<template>
    <div class="empty-wrapper">
        <Head :title="$tc('header.back')"/>
        <Empty :emptydata="emptydata"/>
    </div>
</template>

<script>

import { mapMutations } from 'vuex'

export default {
    name: '404',
    data () {
        return {
            emptydata: null
        }
    },
    created () {
        this.emptydata = {
            type: 'nodata'
        }
        this.setShowLoading(false)
    },
    methods: {
        ...mapMutations(['setShowLoading'])
    }
}

</script>
